<template>
  <!-- Welcome's art: the board's three faint rings, one per player colour,
       offset left to right. From 700 px they sit over the app's fractal
       (WelcomeFractal). -->
  <svg
    class="welcome-rings"
    width="390"
    height="520"
    viewBox="0 0 390 520"
    aria-hidden="true"
    focusable="false"
  >
    <circle
      cx="160"
      cy="250"
      r="210"
      style="stroke: var(--cl-person-1); stroke-opacity: 0.1"
    />
    <circle
      cx="195"
      cy="250"
      r="170"
      style="stroke: var(--cl-person-2); stroke-opacity: 0.09"
    />
    <circle
      cx="230"
      cy="250"
      r="130"
      style="stroke: var(--cl-person-3); stroke-opacity: 0.1"
    />
  </svg>
</template>

<script>
export default { name: "WelcomeRings" };
</script>

<style scoped>
/* Centred on the page; the ring centre sits 250 down, or 30% of a short
   window (the app's _RingsPainter). The outer ring reaches 50 past the
   box's left edge, so the box must not clip it. */
.welcome-rings {
  position: absolute;
  overflow: visible;
  left: 50%;
  top: calc(min(250px, 30vh) - 250px);
  transform: translateX(-50%);
  pointer-events: none;
}
.welcome-rings circle {
  fill: none;
  stroke-width: 1.5;
}
</style>
